import { render, staticRenderFns } from "./categoriesV2.vue?vue&type=template&id=77a6d7ee&scoped=true"
import script from "./categoriesV2.vue?vue&type=script&lang=ts"
export * from "./categoriesV2.vue?vue&type=script&lang=ts"
import style0 from "./categoriesV2.vue?vue&type=style&index=0&id=77a6d7ee&prod&lang=css"
import style1 from "./categoriesV2.vue?vue&type=style&index=1&id=77a6d7ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a6d7ee",
  null
  
)

export default component.exports